export default {
    accept_document: "Прийняти",
    agreement_status_not_signed: "Не підписано",
    agreement_status_signed: "Підписано",
    all_other_countries: "Інші країни",
    effective_at: "Дата початку дії",
    legal_agreement: "Угода",
    legal_document: "Юридичний документ",
    legal_document_countries_note: "Якщо не вибрано жодної країни, документ застосовується до всіх країн, для яких немає окремого документа цього типу.",
    legal_document_is_active_note: "Лише одна версія документа цього типу та регіону може бути активною. Активація цієї версії автоматично деактивує попередню активну версію.",
    legal_document_must_accept_note: "Для продовження роботи необхідно ознайомитися та прийняти документ.",
    legal_document_superadmin_authority_note: "Приймаючи документ, ви підтверджуєте наявність повноважень діяти від імені організації.",
    legal_document_type: "Тип документа",
    legal_document_type_offer_contract: "Договір оферти",
    legal_document_type_integrations_agreement: "Угода про використання сторонніх сервісів та інтеграцій",
    legal_document_type_usage_agreement: "Угода про використання програми",
    legal_document_usage_agreement_note: "Приймаючи документ, ви підтверджуєте, що ознайомилися з правилами використання програми та зобов'язуєтеся їх дотримуватися.",
    legal_documents: "Юридичні документи",
    loading: "Завантаження",
    no_legal_documents_for_region: "Для вашого регіону ще не опубліковано жодного документа",
    open_document: "Відкрити документ",
    requires_reacceptance: "Потрібне повторне прийняття",
    requires_reacceptance_note: "Якщо увімкнено, користувачі, які прийняли попередню версію, повинні будуть прийняти цю версію знову під час наступного входу.",
    version: "Версія"
}
